<template>
	<div class="breadcrumb" :style="{background:bgcolor}">
		<router-link :to="'/'" class="link">首页</router-link>
		<span class="link"> > </span>
		<router-link v-for="(item,index) in crumbs" :key="index" :to="item.path" class="link">
			{{ item.title }}
		</router-link>

	</div>
</template>

<script>
	export default {
		name: "Breadcrumb",
		props: {
			crumb: Array,
			bgcolor:{
				type: String,
				default:'#f9f9f9'
			}
		},
		data() {
			return {
				crumbs:[]
			};
		},
		watch: {
			$route(to) {
				this.changeRoute(to)
			},
		},
		created() {
			this.crumbs = this.crumb
		},
		mounted() {

		},
		methods:{
			changeRoute(to){
				this.crumbs = [{
					title: to.meta.title,
					path: to.name,
				}]
			}
		}
	};
</script>

<style scoped lang="scss">
	.breadcrumb {
		width: 1170px;
		height: 40px;
		line-height:40px;
		background: #f9f9f9;
		margin: 0px auto;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #999999;
		text-align: left;
		padding-left: 20px;
		.link:last-child {
			font-weight: bold;
			line-height: 29px;
			color: #333333;
		}

		.link {
			margin-right: 10px;
			color: #999999;
		}
	}
</style>
